<template>
    <form>
        <ui-container :no-padding="noPadding">
            <global-specs-form-classic
                class="py-8 border-b"
                :form="form"
                :estimate="estimate"
            ></global-specs-form-classic>
        </ui-container>

        <ui-container class="py-4 flex justify-end space-x-6" :no-padding="noPadding">
            <ui-button-new v-if="editMode" @click.prevent="edit(false)">Cancel</ui-button-new>
            <ui-button-new v-else @click.prevent="form.reset()">Reset</ui-button-new>
            <ui-button-new primary @click.prevent="form.submit()" :loading="form.busy">
                {{ editMode ? 'Save' : 'Create' }}
            </ui-button-new>
        </ui-container>

    </form>
</template>

<script>
import { GlobalSpec } from '@models'

export default {
    props: {
        item: Object,
        estimate: Object,
        edit: Function,
        addItem: Function,
        noPadding: Boolean,
    },
    data() {
        const initialData = this.item
            ? this.item.getFormAttributes()
            : () => ({
                'unit_of_measure': 'm2',
                'materials': [],
                'labour': [],
                'materials_cost_per_uom': 0,
                'labour_cost_per_uom': 0,
                'cost_per_uom': 0,
            })

        return {
            form: new Form(initialData, async (form) => {
                if (this.editMode) {
                    await this.item.update(form.export())
                    this.edit(false)
                } else {
                    const item = await GlobalSpec.create(form.export())
                    this.addItem(item, 0)

                    form.reset()
                }
            }),
        }
    },
    computed: {
        editMode() {
            return !! this.item
        },
    },
}
</script>
